import { createSelector } from "reselect";
import { ENTITIES_FETCHED } from "../actions/types";

/**
 * used to determine if the entity has a relation to other entities in their schema,  if we, we want it in state.  otherwise we ignore
 * @param schema
 * @param entityType
 * @returns {boolean}
 */
function entityDefinedInSchema(schema, entityType) {
  let isMapped = false;
  if (schema) {
    if (schema._key === entityType) {
      isMapped = true;
    } else {
      Object.values(schema.schema).map(s => {
        if (s._key === entityType) {
          isMapped = true;
        }
      });
    }
  }
  return isMapped;
}
export default function createEntityReducer(entityType = "") {
  return function entities(state = {}, action = {}) {
    if (!entityDefinedInSchema(action.schema, entityType)) return state;
    switch (action.type) {
      case ENTITIES_FETCHED:
        return { ...state, ...action.data[entityType] };
      default:
        return state;
    }
  };
}
const entitySelector = (state, entityType) => state[entityType];
const selectedEntityIdFilter = (state, selectedEntityType, selectedEntityId) =>
  selectedEntityId;

export const allEntitySelector = createSelector(entitySelector, entityHash =>
  Object.values(entityHash)
);
export const entityByIdSelector = createSelector(
  [entitySelector, selectedEntityIdFilter],
  (entities, entityId) => entities[entityId]
);



// WEBPACK FOOTER //
// ./src/reducers/entity.js